import { apiRequest } from "@/api/client";
import type { SavedSearch, SearchFilters } from "@/types/api";

/** Lista as pesquisas salvas do usuário. */
export function listSavedSearches(): Promise<SavedSearch[]> {
  return apiRequest<SavedSearch[]>("/searches");
}

/** Salva uma pesquisa nomeada com os filtros atuais (201 devolve o objeto criado). */
export function createSavedSearch(name: string, filters: SearchFilters): Promise<SavedSearch> {
  return apiRequest<SavedSearch>("/searches", {
    method: "POST",
    body: { name, filters },
  });
}

/** Exclui uma pesquisa salva. */
export function deleteSavedSearch(id: string): Promise<void> {
  return apiRequest<void>(`/searches/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
